import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductDto, ResultWrapper, ScoreRecipientRegDto } from '../dtos/dto';
import { ConfigHelper } from './helpers/config.helper';

@Injectable({
  providedIn: 'root'
})
export class RegistrationManagementService {

  constructor(
    private configHelper: ConfigHelper,
    private http: HttpClient,
  ) { }

  getReEvaluationProducts(regId: number): Observable<ResultWrapper<ProductDto[]>> {
    const params = new HttpParams()
      .set('RegId', regId.toString());
    return this.http.get<ResultWrapper<ProductDto[]>>(this.configHelper.getApiUrl("User/Reg/ReEvaluationProducts"), { params });
  }

  getOneSkillRetakeProducts(regId: number): Observable<ResultWrapper<ProductDto[]>> {
    const params = new HttpParams()
      .set('RegId', regId.toString());
    return this.http.get<ResultWrapper<ProductDto[]>>(this.configHelper.getApiUrl("User/Reg/OneSkillRetakeProducts"), { params });
  }

  getReEvaluationOrderStatus(regId: number): Observable<ResultWrapper<Date>> {
    const params = new HttpParams()
      .set('RegId', regId.toString());
    return this.http.get<ResultWrapper<Date>>(this.configHelper.getApiUrl("User/Reg/ReEvaluationOrderStatus"), { params });
  }

  getReceivingInstitutions(regId: number): Observable<ResultWrapper<ScoreRecipientRegDto[]>> {
    const params = new HttpParams()
      .set('RegId', regId.toString());
    return this.http.get<ResultWrapper<ScoreRecipientRegDto[]>>(this.configHelper.getApiUrl("User/Reg/ReceivingInstitutions"), { params });
  }

  getReceivingInstitutionByTestPurpose(regId: number): Observable<ResultWrapper<ScoreRecipientRegDto>> {
    const params = new HttpParams()
      .set('RegId', regId.toString());
    return this.http.get<ResultWrapper<ScoreRecipientRegDto>>(this.configHelper.getApiUrl("User/Reg/ReceivingInstitutionByTestPurpose"), { params });
  }

  AddScoreRecipientRegularMail(scoreRecipientRegIds: number[]) {
    return this.http.post(this.configHelper.getApiUrl("User/Reg/ScoreRecipientRegularMail"), scoreRecipientRegIds);
  }

}
